const img1 = require('./1.png');
const img2 = require('./2.png');
const img3 = require('./3.png');
const img4 = require('./4.png');
const img5 = require('./5.png');
const img6 = require('./6.png');

export const produtos = [img1, img2, img3, img4, img5, img6];
